import React from 'react'
import { Link } from 'react-router-dom';
import './footer.scss';

import logo from '../../assets/images/logo.svg';

const Footer = () => {
	return (
		<div className='footer-main-container'>
			<div>
				<Link
					to="/"
					className="logo-container"
				>
					<img
						alt="header"
						src={logo}
						className="w-10 m-0"
					/>
					<span className="footer-logo-text">
						mereos
					</span>
				</Link>
			</div>
		</div>
	)
}

export default Footer